<template>
    <div class="jgile-setting">
        <slot :value="value" :save-setting="saveSetting" :delete-setting="deleteSetting"></slot>
    </div>
</template>

<script>
import Form from '@jgile/laravel-vue/resources/js/forms/Form';

export default {
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            setting: new Form({
                key: null,
                value: null,
                type: null,
            }),
        };
    },
    methods: {
        saveSetting() {
            this.query.post(`/api/settings`, this.setting).then((response) => {
                this.$emit('input', response.data);
            });
        },
        deleteSetting() {
            this.query.delete(`/api/settings`, this.setting).then((response) => {
                this.$emit('input', response.data);
            });
        },
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.setting.key = newVal.key;
                this.setting.value = newVal.value;
                this.setting.type = newVal.type;
            },
        },
    },
};
</script>
